import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";

const ErrorModal = ({ show, message, onCloseClick,color=false }: any) => {
  return (
    <Modal
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      className="smallModal erorrModalDv"
      style={{maxWidth: "fit-content",}}
    >
      <ModalBody
        className="py-3 px-5 text-center"
        style={{
          background: !color? "rgb(255 98 98)": "#4df04f",
          color: "white",
          borderRadius: "4px",
        }}
      >
        <p className="p-0 m-0 fs-5 fw-bold text-white">
          {message || "An unexpected error occurred. Please try again."}
        </p>
      </ModalBody>
    </Modal>
  );
};

ErrorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onCloseClick: PropTypes.func.isRequired,
  color:PropTypes.bool
};

export default ErrorModal;
